import {defineNuxtPlugin, useRuntimeConfig} from '#app';
import {useFeatureFlagsStore} from '../store/feature-flags.store';

export default defineNuxtPlugin({
    name: 'nuxt-features-module-load-feature-flags-plugin',
    parallel: true,
    dependsOn: ['fetch-auth'],
    setup: async () => {
        const config = useRuntimeConfig();
        const flagsConfig: string[] = config.public['@malt/nuxt-features-module'].flags || [];

        const {init} = useFeatureFlagsStore();

        await init(flagsConfig);
    },
});
